import { LoadingButtonProps } from "@mui/lab";
import React from "react";

import { Container } from "./ButtonTheme.styled";

interface IButtonProps extends LoadingButtonProps {}

const ButtonTheme: React.FC<IButtonProps> = ({ children, ...rest }) => {
  return (
    <Container variant="contained" {...rest}>
      {children}
    </Container>
  );
};

export { ButtonTheme };
